"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GET = "GET",
    PUT = "PUT",
    POST = "POST",
    DELETE = "DELETE";

exports.default = function (_ref) {
  var dispatch = _ref.dispatch,
      getState = _ref.getState;
  return function (next) {
    return function (action) {
      if (!action.payload || _typeof(action.payload) === "object" && !action.payload.url) {
        return next(action);
      }

      var url = typeof action.payload === "string" ? action.payload : action.payload.url;
      var params = typeof action.payload !== "string" && action.payload.params ? action.payload.params : {};

      switch (action.type.substring(0, action.type.indexOf("_"))) {
        case GET:
          return dispatch({
            type: action.type,
            payload: _axios2.default.get(url, params)
          });
        case PUT:
          return dispatch({
            type: action.type,
            payload: _axios2.default.put(url, params)
          });
        case POST:
          return dispatch({
            type: action.type,
            payload: _axios2.default.post(url, params)
          });
        case DELETE:
          return dispatch({
            type: action.type,
            payload: _axios2.default.delete(url, params)
          });
        default:
          return next(action);
      }
    };
  };
};